"use client";

import Image from "next/image";

type EventInfoCardProps = {
  label: string;
  title: string;
  subtitle?: string;
  image?: string;
  children?: React.ReactNode;
  linkLabel?: string;
  linkHref?: string;
};

export function EventInfoCard({
  label,
  title,
  subtitle,
  image,
  children,
  linkLabel,
  linkHref,
}: EventInfoCardProps) {
  return (
    <div className="group flex h-full items-center gap-5 rounded-[2rem] border border-white/70 bg-white/82 p-5 shadow-[0_22px_54px_rgba(101,86,73,0.12)] backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:shadow-[0_28px_64px_rgba(101,86,73,0.16)]">
      {image ? (
        <div className="relative h-24 w-24 shrink-0 overflow-hidden rounded-[1.4rem] bg-white shadow-[0_14px_30px_rgba(115,98,82,0.12)]">
          <Image
            src={image}
            alt={title}
            fill
            sizes="96px"
            className="object-cover"
          />
        </div>
      ) : null}

      <div className="space-y-1.5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-700/85">
          {label}
        </p>

        <h3 className="font-display text-2xl leading-tight text-foreground">
          {title}
        </h3>

        {subtitle ? (
          <p className="text-sm leading-6 text-gray-600">{subtitle}</p>
        ) : null}

        {children}

        {linkLabel && linkHref ? (
          <a
            href={linkHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block pt-1 text-sm font-medium text-amber-700 underline-offset-4 transition group-hover:text-amber-800 hover:underline"
          >
            {linkLabel}
            {" ->"}
          </a>
        ) : null}
      </div>
    </div>
  );
}
